<template>
	<div class="app-container">
	  <router-view />
	</div>
</template>

<script>
export default {
  name: 'Monitor'
}
</script>

<style>
</style>
